import { FormControl, TextField } from '@mui/material';

const CustomDateInput = ({ formik, label, name }) => {
    return (
        <FormControl fullWidth>
            <TextField
                id={name}
                type={"date"}
                name={name}
                label={label}
                variant="outlined"
                value={formik.values[name]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched[name] && !!formik.errors[name]}
                helperText={formik.touched[name] && formik.errors[name] ? formik.errors[name] : ""}
                fullWidth
            />
        </FormControl>
    );
};

export default CustomDateInput;
